import ReassignSellerModal from './ReassignSellerModal';

export default ReassignSellerModal;
